<template>
  <div>
    <div class="maxbox">
      <div>
        <div class="wallet-info">
          <p>钱包地址: {{ shortWalletAddress }}</p>
          <p>USDT 余额: {{ usdtBalance }} USDT</p>
          <p>TORNADO 余额: {{ sbsBalance }} TORNADO</p>
        </div>

        <div class="main">
          <button class="return" @click="goback">
            <img src="@/assets/images/left-arrow.png" alt="" />
          </button><br>

          <!-- 显示合约部署者标识 -->
          <div v-if="isDeployer">
            <p>您是合约部署者: {{ deployerAddress }}</p>
            <!-- 设置新的汇率 -->
            <div>
              <label for="newExchangeRate">设置新的汇率 (USDT/TORNADO):</label>
              <input type="number" id="newExchangeRate" v-model="newExchangeRate" step="0.000001" />
              <button @click="setExchangeRate">设置汇率</button>
            </div>
            <!-- 设置新的手续费率 -->
            <div>
              <label for="newExchangeFeeRate">设置新的手续费率 (%):</label>
              <input type="number" id="newExchangeFeeRate" v-model="newExchangeFeeRate" min="0" max="100" step="0.000001" />
              <button @click="setExchangeFeeRate">设置手续费率</button>
            </div>
            <!-- 实时显示合约余额 -->
            <div>
              <p>USDT 余额: {{ contractUsdtBalance }} USDT</p>
              <p>TORNADO 余额: {{ contractSbsBalance }} TORNADO</p>
            </div>

            <!-- 新增：管理员创建买单 -->
            <div>
              <label>创建收购买单 - 价格(USDT/TORNADO):</label>
              <input type="number" v-model="orderPrice" step="0.000001" />
            </div>
            <div>
              <label>创建收购买单 - 数量(TORNADO):</label>
              <input type="number" v-model="orderAmount" step="0.000001" />
              <button @click="createBuyOrders">创建买单</button>
            </div>

            <!-- ====================== 批量删除买单 ====================== -->
            <div>
              <label>批量删除买单（输入删除数量）:</label>
              <input type="number" v-model.number="deleteOrderCount" min="1" />
              <button @click="deleteBuyOrders">删除订单</button>
            </div>

            <!-- ====================== ✅ 每日时间设置（只选小时，自动循环） ====================== -->
            <div style="margin-top:12px;">
              <label>交易时间限制开关：</label>
              <button @click="toggleTradeTime" style="padding:4px 8px;">
                {{ tradeTimeEnabled ? "✅ 已开启限制" : "❌ 已关闭限制" }}
              </button>
            </div>

            <div style="margin-top:8px;">
              <label>每日开始时间（时:分）：</label>
              <input type="time" v-model="dailyStartTime" />
            </div>

            <div style="margin-top:8px;">
              <label>每日结束时间（时:分）：</label>
              <input type="time" v-model="dailyEndTime" />
            </div>

            <div style="margin-top:8px;">
              <button @click="setDailyTradeTime" style="padding:6px 12px;background:#0984e3;color:white;border:none;border-radius:4px;">
                保存每日交易时间
              </button>
            </div>

            <!-- 存入 USDT -->
            <div>
              <label for="depositUsdtAmount">存入 USDT 数量:</label>
              <input type="number" id="depositUsdtAmount" v-model="depositUsdtAmount" step="0.000001" />
              <button @click="depositUSDT">存入 USDT</button>
            </div>
            <!-- 存入 TORNADO -->
            <div>
              <label for="depositSbsAmount">存入 TORNADO 数量:</label>
              <input type="number" id="depositSbsAmount" v-model="depositSbsAmount" step="0.000001" />
              <button @click="depositSBS">存入 TORNADO</button>
            </div>
            <!-- 提取 USDT -->
            <div>
              <label for="withdrawUsdtAmount">提取 USDT 数量:</label>
              <input type="number" id="withdrawUsdtAmount" v-model="withdrawUsdtAmount" step="0.000001" />
              <button @click="withdrawUSDT">提取 USDT</button>
            </div>
            <!-- 提取 TORNADO -->
            <div>
              <label for="withdrawSbsAmount">提取 TORNADO 数量:</label>
              <input type="number" id="withdrawSbsAmount" v-model="withdrawSbsAmount" step="0.000001" />
              <button @click="withdrawSBS">提取 TORNADO</button>
            </div>
          </div>

          <div id="referrals" class="referrals-container">
            <div v-for="(member, index) in teamMembers" :key="index" class="pyuser">
              <img src="@/assets/images/pyusers.png" alt="" />
              <p class="address">{{ member }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ethers } from "ethers";
import { usdtTokenAddress, usdtAbi, tokenExchangeAddress, tokenExchangeAbi, sbsTokenAddress, sbsTokenABI } from '@/js/contractss.js';

export default {
  name: "myteam",
  data() {
    return {
      teamMembers: [],
      userAddress: '',
      shortWalletAddress: '',
      usdtBalance: 0,
      sbsBalance: 0,
      deployerAddress: '',
      newExchangeRate: 0,
      newExchangeFeeRate: 0,
      contractUsdtBalance: 0,
      contractSbsBalance: 0,
      depositUsdtAmount: 0,
      depositSbsAmount: 0,
      isDeployer: false,
      withdrawUsdtAmount: 0,
      withdrawSbsAmount: 0,
      refreshInterval: null,
      orderPrice: 0,
      orderAmount: 0,

      // ====================== 每日时间模式 ======================
      deleteOrderCount: 1,
      tradeTimeEnabled: false,
      dailyStartTime: "09:00",   // 每天开始
      dailyEndTime: "21:00",     // 每天结束
    };
  },
  methods: {
    goback() {
      this.$router.go(-1);
    },
    async connectWallet() {
      if (window.ethereum) {
        try {
          await window.ethereum.request({ method: "eth_requestAccounts" });
          return new ethers.providers.Web3Provider(window.ethereum);
        } catch (error) {
          console.error("用户拒绝了账户访问请求", error);
        }
      } else {
        console.error("未检测到Ethereum提供商。请安装MetaMask。");
      }
    },
    async fetchData() {
      const provider = await this.connectWallet();
      if (!provider) return;

      const signer = provider.getSigner();
      const contract = new ethers.Contract(tokenExchangeAddress, tokenExchangeAbi, signer);

      try {
        const userAddress = await signer.getAddress();
        if (!userAddress) {
          alert("无法检测到用户地址，请先连接到MetaMask。");
          return;
        }

        this.userAddress = userAddress;
        this.shortWalletAddress = `${userAddress.slice(0, 6)}...${userAddress.slice(-4)}`;

        const usdtContract = new ethers.Contract(usdtTokenAddress, usdtAbi, provider);
        const usdtBalance = await usdtContract.balanceOf(userAddress);
        this.usdtBalance = ethers.utils.formatUnits(usdtBalance, 6);

        const sbsContract = new ethers.Contract(sbsTokenAddress, sbsTokenABI, provider);
        const sbsBalance = await sbsContract.balanceOf(userAddress);
        this.sbsBalance = ethers.utils.formatUnits(sbsBalance, 6);

        const deployerAddress = await contract.deployer();
        this.deployerAddress = deployerAddress;

        this.isDeployer = this.userAddress.toLowerCase() === this.deployerAddress.toLowerCase();

        if (this.isDeployer) {
          await this.getContractBalances();
          this.tradeTimeEnabled = await contract.tradeTimeEnabled();
        }

      } catch (error) {
        console.error("查询数据失败", error);
        alert("查询失败，请确保已连接到MetaMask并检查网络。");
      }
    },
    async createBuyOrders(){
      if(!this.isDeployer){
        alert("无权限操作");
        return;
      }
      const provider = await this.connectWallet();
      if (!provider) return;
      const signer = provider.getSigner();
      const contract = new ethers.Contract(tokenExchangeAddress, tokenExchangeAbi, signer);

      try {
        const price = ethers.utils.parseUnits(this.orderPrice.toString(), 6);
        const amount = ethers.utils.parseUnits(this.orderAmount.toString(), 6);
        const tx = await contract.createBuyOrders([price], [amount]);
        await tx.wait();
        alert("买单创建成功");
      } catch (error) {
        console.error("创建买单失败", error);
        alert("创建买单失败");
      }
    },

    // ====================== 批量删除订单 ======================
    async deleteBuyOrders() {
      if (!this.isDeployer) { alert("无权限"); return; }
      if (this.deleteOrderCount < 1) { alert("请输入正确数量"); return; }
      
      const provider = await this.connectWallet();
      const signer = provider.getSigner();
      const contract = new ethers.Contract(tokenExchangeAddress, tokenExchangeAbi, signer);
      
      try {
        const tx = await contract.deleteBuyOrders(this.deleteOrderCount);
        await tx.wait();
        alert("订单删除成功");
      } catch (e) {
        console.error(e);
        alert("删除失败：" + e.message);
      }
    },

    // ====================== ✅ 设置每日交易时间（自动每天循环） ======================
    async setDailyTradeTime() {
      if (!this.isDeployer) { alert("无权限"); return; }

      const now = new Date();
      const today = now.toISOString().split("T")[0];

      const start = new Date(`${today}T${this.dailyStartTime}:00`);
      const end = new Date(`${today}T${this.dailyEndTime}:00`);

      if (end <= start) {
        alert("结束时间必须大于开始时间");
        return;
      }

      const startTimeStamp = Math.floor(start.getTime() / 1000);
      const endTimeStamp = Math.floor(end.getTime() / 1000);

      const provider = await this.connectWallet();
      const signer = provider.getSigner();
      const contract = new ethers.Contract(tokenExchangeAddress, tokenExchangeAbi, signer);

      try {
        const tx = await contract.setTradeTime(startTimeStamp, endTimeStamp);
        await tx.wait();
        alert("每日交易时间设置成功！\n每天 " + this.dailyStartTime + " ~ " + this.dailyEndTime + " 开放交易");
      } catch (e) {
        console.error(e);
        alert("设置失败：" + e.message);
      }
    },

    // ====================== 开关时间限制 ======================
    async toggleTradeTime() {
      if (!this.isDeployer) { alert("无权限"); return; }
      const provider = await this.connectWallet();
      const signer = provider.getSigner();
      const contract = new ethers.Contract(tokenExchangeAddress, tokenExchangeAbi, signer);
      
      try {
        const tx = await contract.setTradeTimeEnabled(!this.tradeTimeEnabled);
        await tx.wait();
        this.tradeTimeEnabled = !this.tradeTimeEnabled;
        alert("已" + (this.tradeTimeEnabled ? "开启✅" : "关闭❌") + "交易时间限制");
      } catch (e) {
        console.error(e);
        alert("操作失败：" + e.message);
      }
    },

    async setExchangeRate() {
      const provider = await this.connectWallet();
      if (!provider) return;
      const signer = provider.getSigner();
      const contract = new ethers.Contract(tokenExchangeAddress, tokenExchangeAbi, signer);
      try {
        const rate = ethers.utils.parseUnits(this.newExchangeRate.toString(), 6);
        const tx = await contract.setExchangeRate(rate);
        await tx.wait();
        alert("汇率设置成功");
        this.fetchData();
      } catch (error) {
        console.error("设置汇率失败", error);
        alert("设置汇率失败");
      }
    },
    async setExchangeFeeRate() {
  if (this.newExchangeFeeRate < 0 || this.newExchangeFeeRate >= 100) {
    alert("手续费率必须在 0% ~ 99.9999%");
    return;
  }
  const provider = await this.connectWallet();
  const signer = provider.getSigner();
  const contract = new ethers.Contract(tokenExchangeAddress, tokenExchangeAbi, signer);
  try {
    // 百分比转合约1e6分母费率
    const percentVal = Number(this.newExchangeFeeRate);
    const feeRate = ethers.BigNumber.from(Math.round(percentVal * 10000));
    const tx = await contract.setExchangeFeeRate(feeRate);
    await tx.wait();
    alert("手续费率设置成功");
    this.fetchData();
  } catch (error) {
    console.error("设置手续费率失败", error);
    alert("设置失败：" + error.message);
  }
}
,
    async getContractBalances() {
      const provider = await this.connectWallet();
      if (!provider) return;
      const signer = provider.getSigner();
      const contract = new ethers.Contract(tokenExchangeAddress, tokenExchangeAbi, signer);
      try {
        const [usdtBalance, sbsBalance] = await contract.getContractBalances();
        this.contractUsdtBalance = ethers.utils.formatUnits(usdtBalance, 6);
        this.contractSbsBalance = ethers.utils.formatUnits(sbsBalance, 6);
      } catch (error) {
        console.error("获取合约余额失败", error);
      }
    },
    async depositUSDT() {
      const provider = await this.connectWallet();
      const signer = provider.getSigner();
      const contract = new ethers.Contract(tokenExchangeAddress, tokenExchangeAbi, signer);
      const usdtContract = new ethers.Contract(usdtTokenAddress, usdtAbi, signer);
      const amount = ethers.utils.parseUnits(this.depositUsdtAmount.toString(), 6);
      try {
        const allowance = await usdtContract.allowance(this.userAddress, tokenExchangeAddress);
        if (allowance.lt(amount)) {
          const approveTx = await usdtContract.approve(tokenExchangeAddress, amount);
          await approveTx.wait();
        }
        const tx = await contract.depositUSDT(amount);
        await tx.wait();
        alert("USDT 存入成功");
        this.fetchData();
      } catch (error) {
        console.error("存入失败", error);
        alert("存入失败");
      }
    },
    async depositSBS() {
      const provider = await this.connectWallet();
      const signer = provider.getSigner();
      const contract = new ethers.Contract(tokenExchangeAddress, tokenExchangeAbi, signer);
      const sbsContract = new ethers.Contract(sbsTokenAddress, sbsTokenABI, signer);
      const amount = ethers.utils.parseUnits(this.depositSbsAmount.toString(), 6);
      try {
        const allowance = await sbsContract.allowance(this.userAddress, tokenExchangeAddress);
        if (allowance.lt(amount)) {
          const approveTx = await sbsContract.approve(tokenExchangeAddress, amount);
          await approveTx.wait();
        }
        const tx = await contract.depositSBS(amount);
        await tx.wait();
        alert("SBS 存入成功");
        this.fetchData();
      } catch (error) {
        console.error("存入失败", error);
        alert("存入失败");
      }
    },
    async withdrawUSDT() {
      const provider = await this.connectWallet();
      const signer = provider.getSigner();
      const contract = new ethers.Contract(tokenExchangeAddress, tokenExchangeAbi, signer);
      const amount = ethers.utils.parseUnits(this.withdrawUsdtAmount.toString(), 6);
      try {
        const tx = await contract.withdrawUSDT(amount);
        await tx.wait();
        alert("USDT 提取成功");
        this.fetchData();
      } catch (error) {
        console.error("提取失败", error);
        alert("提取失败");
      }
    },
    async withdrawSBS() {
      const provider = await this.connectWallet();
      const signer = provider.getSigner();
      const contract = new ethers.Contract(tokenExchangeAddress, tokenExchangeAbi, signer);
      const amount = ethers.utils.parseUnits(this.withdrawSbsAmount.toString(), 6);
      try {
        const tx = await contract.withdrawSBS(amount);
        await tx.wait();
        alert("SBS 提取成功");
        this.fetchData();
      } catch (error) {
        console.error("提取失败", error);
        alert("提取失败");
      }
    },
    startContractBalanceRefresh() {
      this.refreshInterval = setInterval(() => {
        if (this.isDeployer) this.getContractBalances();
      }, 10000);
    },
    stopContractBalanceRefresh() {
      if (this.refreshInterval) {
        clearInterval(this.refreshInterval);
        this.refreshInterval = null;
      }
    },
  },
  mounted() {
    this.fetchData();
    this.startContractBalanceRefresh();
  },
  beforeDestroy() {
    this.stopContractBalanceRefresh();
  },
};
</script>

<style scoped>
@import "@/assets/css/team.css";
@import "@/assets/css/style.css";

.main {
  padding-top: 50px;
}

.referrals-container {
  max-height: 400px;
  overflow-y: auto;
}

.pyuser {
  display: flex;
  align-items: center;
  gap: 10px;
}

.address {
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
}

.top {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.wallet-info {
  text-align: right;
}
</style>
